import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Download from '../components/Download';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Randevu345 - Salon Yönetimi Hiç Bu Kadar Kolay Olmamıştı</title>
        <meta name="description" content="Randevu takibinden muhasebe yönetimine kadar tüm süreçlerinizi tek platformda yönetin. Modern, hızlı ve güvenilir salon yönetim sistemi. 5 dakikada kurulum, 7/24 destek." />
        <meta name="keywords" content="randevu yönetimi, salon yönetimi, kuaför programı, berber programı, güzellik salonu yazılımı, randevu sistemi, salon otomasyonu, müşteri yönetimi, online randevu, salon yazılımı" />
        <link rel="canonical" href="https://345.com.tr/" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Randevu345 - Salon Yönetimi Hiç Bu Kadar Kolay Olmamıştı" />
        <meta property="og:description" content="Randevu takibinden muhasebe yönetimine kadar tüm süreçlerinizi tek platformda yönetin. Modern, hızlı ve güvenilir salon yönetim sistemi." />
        <meta property="og:url" content="https://345.com.tr/" />
        <meta property="og:type" content="website" />
        
        {/* Twitter */}
        <meta name="twitter:title" content="Randevu345 - Salon Yönetimi Hiç Bu Kadar Kolay Olmamıştı" />
        <meta name="twitter:description" content="Randevu takibinden muhasebe yönetimine kadar tüm süreçlerinizi tek platformda yönetin. Modern, hızlı ve güvenilir salon yönetim sistemi." />
      </Helmet>
      
      <Hero />
      <Features />
      <Download />
    </>
  );
};

export default Home; 